import { Theme } from '@mui/material';
import { GeneralContentProps } from '../interfaces/generalContentProps';
import { hexToRgba } from '../utils/generalContent';
import { makeStyles } from 'tss-react/mui';

export const Layout10Styles = makeStyles<GeneralContentProps>()((theme: Theme, props) => ({
  accordionWrapper: {
    '& .MuiAccordion-rounded': {
      borderRadius: '0px',
      margin: '0 !important',
    },
    '& > *:not(:last-child)': {
      borderBottom: 'none',
    },

    '& .MuiPaper-root': {
      background: props.contentContainerBackgroundColor,
    },

    /** When only child(FAQ tile is available) */
    '& > div:only-child': {
      borderRadius: '6px 6px 6px 6px !important',
      '& .MuiAccordionSummary-root': {
        borderRadius: '6px 6px 6px 6px !important',
      },
      '& .MuiAccordionSummary-root.Mui-expanded': {
        borderRadius: '6px 6px 0px 0px !important',
      },
      '& .MuiAccordionDetails-root': {
        borderRadius: '0px 0px 6px 6px !important',
      },
    },

    /** When more than one child(FAQ tile is available) */
    '& > div:first-child': {
      borderRadius: '6px 6px 0px 0px',
      '& .MuiAccordionSummary-root': {
        borderRadius: '6px 6px 0px 0px',
      },
    },

    '& > div:last-child': {
      borderRadius: '0px 0px 6px 6px',
      '& .MuiAccordionSummary-root': {
        borderRadius: '0px 0px 6px 6px',
      },
      '& .MuiAccordionSummary-root.Mui-expanded': {
        borderRadius: '0px',
      },
      '& .MuiAccordionDetails-root': {
        borderRadius: '0px 0px 6px 6px',
      },
    },
  },
  accordion: {
    border: `1px solid ${hexToRgba(`${props.contentTextColor}`, 50)}`,
    '& .MuiAccordionSummary-root': {
      paddingLeft: '0px',
      background: props.contentContainerBackgroundColor,
    },
    '& .MuiAccordionSummary-root:hover': {
      fontWeight: 600,
    },
    [theme.breakpoints.up('lg')]: {
      '& .MuiAccordionSummary-root:hover': {
        background: `color-mix(in srgb, ${props.contentTextColor} 5%, ${props.contentContainerBackgroundColor})`,
      },
    },
  },
  accordionSummary: {
    color: props.contentTextColor,
    '& .MuiSvgIcon-root': {
      '& > path': {
        fill: props.contentTextColor,
      },
    },
    '&.Mui-expanded': {
      borderBottom: `1px solid ${hexToRgba(`${props.contentTextColor}`, 50)}`,
      background: `color-mix(in srgb, ${props.contentTextColor} 5%, ${props.contentContainerBackgroundColor});`,
      fontWeight: 600,
    },
    fontSize: '18px',
    lineHeight: '25px',
    '& .MuiAccordionSummary-content': {
      paddingLeft: '24px',
      paddingTop: '14px',
      paddingBottom: '14px',
      margin: '0px',
    },
  },
  accordionDetails: {
    color: props.contentTextColor,
    flexDirection: 'column',
    background: props.contentContainerBackgroundColor,
    padding: '24px',
    borderLeft: `6px solid ${props.stripColor}`,
    '& > div': {
      '& > p': {
        margin: 0,
      },
    },
  },
  positionRelative: {
    position: 'relative',
  },
  gridContainer: {
    color: props.titleColor,
    wordBreak: 'break-word',
    backgroundSize: 'cover',
    overflow: 'hidden',
    display: 'list-item',
    justifyContent: 'center',
    alignItems: 'center',
    background: props.backgroundColor,
  },
}));
